// extracted by mini-css-extract-plugin
export default {"page_wrapper":"earnings_page_wrapper__-Ay-M","stats_boxes":"earnings_stats_boxes__FkcUM","title_bar_earnings":"earnings_title_bar_earnings__1qVsN"};